import { Controller } from 'stimulus';
import Sortable from 'sortablejs';

export default class extends Controller {
  static values = {
    handle: { type: String, default: '' },
    draggable: { type: String, default: '>*' },
    direction: { type: String, default: 'vertical' },
    animation: { type: Number, default: 150 },
  };

  #sortable;

  connect() {
    this.#sortable = Sortable.get(this.element) || Sortable.create(this.element, this.#options);
  }

  disconnect() {
    if (!this.element.isConnected) {
      this.#sortable?.destroy();
      this.#sortable = null;
    }
  }

  _updateSortOrder(event) {
    // I can be overridden by my subclasses
  }

  _onStartDragging(event) {
    // I can be overridden by my subclasses
  }

  _onEndDragging(event) {
    // I can be overridden by my subclasses
  }

  _onItemAdded(event) {
    // I can be overridden by my subclasses
  }

  _groupOptions() {
    // I can be overridden by my subclasses
    return {};
  }

  _extraOptions() {
    return {};
  }

  get #options() {
    return {
      forceFallback: true,
      animation: this.animationValue,
      direction: this.directionValue,
      draggable: this.draggableValue,
      handle: this.handleValue,
      ...this._groupOptions(),
      ...this._extraOptions(),
      onStart: (event) => this._onStartDragging(event),
      onEnd: (event) => this._onEndDragging(event),
      onUpdate: (event) => this._updateSortOrder(event),
      onAdd: (event) => this._onItemAdded(event),
    };
  }
}
